<template>
    <div class="preAlert">
        <div class="box-white-wrapper">
            <form-wizard :color="color" error-color="#e74c3c" title="" ref="wizard" subtitle="">
                <tab-content title="Datos del paquete" :before-change="validStepOneForm">
                    <div class="assignTo" v-if="userInfoData.role === Roles.Admin">
                        <div class="to-customer">
                            <p>¿Desea asignar la prealerta a un cliente?:</p> 
                            <vs-switch v-model="assignTo" color="success"/>
                        </div>
                        <div class="form-input" v-if="assignTo">
                        <select-input :options="customers" v-model="customer"></select-input>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.pack.tracking.$error }]">
                            <vs-input label="Número de tracking" v-model.trim="$v.pack.tracking.$model" @change="validTracking"/>
                            <span class="error-text" v-if="$v.pack.tracking.$error && errorTracking == ''"><feather type="info" />Este campo es requerido</span>
                            <span class="error-text" v-if="errorTracking != ''">{{ errorTracking }}</span>
                        </div>
                        <div :class="['form-input',{'has-error': $v.pack.guide.$error }]">
                            <vs-input label="Número de orden" v-model.trim="$v.pack.guide.$model"/>
                        <span class="error-text" v-if="$v.pack.guide.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': $v.pack.tax.$error }]">
                            <label class="vs-input--label">Producto <small class="needPermission" v-if="pack.tax.permission == 1">(requiere permiso)</small></label>
                            <select-input :options="products" v-model="$v.pack.tax.$model"></select-input>
                            <span class="error-text" v-if="$v.pack.tax.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <!-- <div :class="['form-input',{'has-error': $v.pack.unit.$error }]">
                            <label class="vs-input--label">Unidad</label>
                            <select-input :options="units" v-model="$v.pack.unit.$model"></select-input>
                            <span class="error-text" v-if="$v.pack.unit.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group"> -->
                        <div :class="['form-input',{'has-error': $v.pack.weight.$error }]">
                            <vs-input label="Peso (lb)" v-model.trim="$v.pack.weight.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.pack.weight.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div :class="['form-input',{'has-error': !$v.pack.price.required }, {'has-error': !$v.pack.price.minValue }]">
                            <vs-input label="Precio (USD)" v-model.trim="$v.pack.price.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="!$v.pack.price.required && $v.pack.price.$error"><feather type="info" />Este campo es requerido</span>
                            <span class="error-text" v-if="!$v.pack.price.minValue && $v.pack.price.required"><feather type="info" />El valor debe ser numérico</span>
                        </div>
                    </div>
                </tab-content>
                <tab-content title="Información adicional" :before-change="validStepTwoForm">
                    <div class="aditionalInfo">
                        <div :class="['wrap-upload',{'border-error': $v.pack.resource.$error }]">
                            <div class="preview" v-if="pack.resource != ''" @click="popupActivo4=true">
                                <img :src="checkExtension(pack.resource)" alt="">
                            </div>
                            <div class="attach" @click="popupActivo4=true" v-if="pack.resource == ''">
                                Adjuntar factura
                                <img src="@/assets/images/uploadFile.png" alt="">
                            </div>
                            <span class="removeInvoice" v-if="pack.resource != ''" @click="removeResource()"><feather type="x-circle" /></span>
                        </div>
                        <div class="detail">
                            <div class="group">
                                <div :class="['form-input',{'has-error': $v.pack.delivery.$error }]">
                                    <label class="vs-input--label">Lugar de Retiro</label>
                                    <select-input :options="deliveries" v-model="$v.pack.delivery.$model"></select-input>
                                    <span class="error-text" v-if="$v.pack.delivery.$error"><feather type="info" />Este campo es requerido</span>
                                </div>
                            </div>
                            <div class="group">
                                <div class="form-input">
                                    <vs-input label="Comentarios" v-model.trim="pack.comments" placeholder="Favor indicarnos la tienda donde realizaste la compra"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab-content>
                <tab-content title="Resumen">
                    <div class="wrp-boxes">
                        <div class="box" v-if="costs.length > 0">
                            <div class="head">
                                <div class="icon">
                                    <img src="@/assets/images/box-open.svg" alt="">
                                </div>
                                <div class="title">El costo aproximado de tu pre alerta es de:</div>
                            </div>
                            <div class="cost"><p>${{getTotalPayment()}}</p></div>
                            <div class="detail"> 
                                <!-- <div class="item">Precio del producto <span>${{formatNumber(pack.price)}}</span></div>  -->
                                <div class="item">Precio del transporte<span>${{formatNumber(costs[0].amount)}}</span></div> 
                                <!-- <div class="item">Protección <span>${{formatNumber(costs[1].amount)}}</span></div>  -->
                                <div class="item">Impuesto de aduana<span>${{formatNumber(totalTax)}}</span></div> 
                                <div class="item" v-if="pack.tax.permission == 1">Permiso PROCOMER<span>${{formatNumber(pack.tax.permissionCost)}}</span></div> 
                                <div class="item">Total<span>${{ getTotalPayment()}}</span></div>
                            </div>
                            <vs-button color="primary" type="border" icon="" id="btnPaid" class="vs-con-loading__container" :disabled="confirmStatus" 
                                    @click="handlePreAlert">Registrar</vs-button>
                            
                            <div class="alertGAM" v-if="!insideGAM()">
                                La dirección de entrega registrada, nos indica que te encuentras fuera del GAM, por lo que se le puede sumar un costo de entrega al paquete.
                            </div>

                        </div>
                        <!-- <div class="box">
                        <VCreditCard @change="creditInfoChanged" :trans="translations" direction="row" :noCard="true"/>
                        <div class="buttonPay">
                            <vs-button color="primary" type="filled" icon="payment" 
                                :disabled="confirmStatus" id="btnConfirm" class="vs-con-loading__container" @click="handlePreAlert">Pagar   Paquete</vs-button>
                        </div>
                        </div> -->
                    </div>
                    <div class="notes">
                        <div class="title">Ten en cuenta</div>
                        <p>&bull; La pre alerta esta sujeta al tipo de cambio y peso.</p>
                        <p>&bull; La pre alerta incluye la entrega a domicilio dentro del área metropolitana.</p>
                        <p>&bull; Si tu paquete pesa más de 10 kilos contacta al servicio al cliente.</p>
                    </div>
                </tab-content>
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" :style="props.fillButtonStyle">Atras</wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Siguiente</wizard-button>
                    </div>
                </template>
                
            </form-wizard>
        
        </div>       
        <vs-popup class="media-wrapper" fullscreen title="Factura de compra" :active.sync="popupActivo4">
            <vs-tabs>
                <vs-tab label="Galería">
                    <div class="media-content">
                        <div :class="['gallery', { w100: resourceSelected === 0}]">
                            <div class="wrrapper">
                                <template v-for="(image, index) in resources" >
                                    <div :key="`s-${index}`" :class="['sigle-image', {active: resourceSelected.id === image.id}]">
                                      <img :src="checkExtension(image.url)" alt="" @click="findResource(image.id, index)">
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="gallery-sidebar" v-if="resourceSelected !== 0">
                            <div class="detail">
                                <div class="title">Factura</div>
                                <div class="feature">
                                    <a :href="resourceSelected.url" target="_blank">
                                        <img :src="checkExtension(resourceSelected.url)"/>
                                    </a>
                                </div>
                                <div class="actions">
                                    <vs-button color="success" type="border" icon="check" @click="closeModalResource">Seleccionar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                
                <vs-tab label="Subir Factura">
                    <div class="dropzone-wrapper">
                        <vue-dropzone :options="dropzoneOpts" id="upload-images"
                            v-on:vdropzone-success="successUploaded" v-on:vdropzone-sending="sendingBeforeDropzone"> </vue-dropzone>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vs-popup>

        <!-- <modalNewToUser @modal-event="handleCloseNew" :show="modalNew"></modalNewToUser> -->
    

    </div>
</template>
<script>
//local registration
import { mapState } from 'vuex'
import {helper} from '@/helpers/utils'
import vueDropzone from 'vue2-dropzone'
import { Role } from '@/helpers/Role.js'
import Http  from '@/helpers/Http.js'
// import VCreditCard from 'v-credit-card'
import 'v-credit-card/dist/VCreditCard.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import PackageModel from "@/models/PackageModel"
import { required, minValue} from 'vuelidate/lib/validators' 
import TaxDataService from "@/services/TaxDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import ClientDataService from "@/services/ClientDataService"
import PackageDataService from "@/services/PackageDataService"
import ResourceDataService from "@/services/ResourceDataService"

// import modalNewToUser from '@/components/Modal/NewToUser.vue'
const translations = {
    name: {  label: 'Nombre', placeholder: 'Nombre completo'},
    card: { label: 'Número de tarjeta', placeholder: 'Número de tarjeta'},
    expiration: { label: 'Expiración' },
    security: { label: 'Código de seguridad', placeholder: 'CVC' }
};
export default {
  name: "PreAlertPacakge",
  mixins: [helper],
  components:{
    SelectInput,
    // VCreditCard,
    // modalNewToUser,
    vueDropzone
  },
  data () {
    return {
      popupActivo4:false,
      resourceSelected: 0,
      translations,
      confirmStatus: false,  
      units: [
        {
            code: 'lb',
            name: 'Libras'
        }
      ],
      costs:[],
      assignTo: false,
      customer: "",
      customers:[],
      deliveries: [],
      products: [],
      pack: new PackageModel(),
      title: "",
      subtitle: "",  
      color: '#1a426d',
      Roles: [],
      resources:[],
      totalTax: 0,
      errorTracking: "",
      modalNew: false,
    }
  },
  validations: {
    pack:{
        id: { required },
        tracking: { required },
        guide:    { required },
        tax:  { required },
        price:    { required, minValue: minValue(0) },
        unit:     { required },
        weight:   { required },
        resource: { required },
        delivery: { required },
        // comments: { required },
        // cardName: { required },
        // cardNumber: { required },
        // cardExp: { required },
        // cardCVC: { required },
        // status:   { required },
    },
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted () {
    this.retrieveTaxes();
    this.retrieveResources()
    this.retrieveLocationsDelivery();
    // let readNote = localStorage.getItem('readNew2');
    // if(readNote == null){
    //   this.modalNew = true;
    // }
  },
  created(){
    this.Roles = Role
    if(this.Roles.Distribuitor === this.userInfoData.role){
        this.$router.push({ name: "packages"})
        this.$vs.notify({title:'Información!',text:'Acceso denegado!',color:'danger',icon:'error_outline'})
    }
    
    if(this.Roles.Admin === this.userInfoData.role){
        this.retrieveCustomers()
    }

  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
    dropzoneOpts() {
       return {
            url: Http.defaultApi + '/files/upload',
            thumbnailWidth: 150,
            maxFilesize: 5,
            method: "POST",
            withCredentials: false,
            acceptedFiles: ".jpg,.jpeg,.png,.gif,.mp4, .pdf",
            headers: { 
            'Access-Control-Allow-Origin': '*',
            'authorization':  this.userInfoData.boxkey,
            'x-access-token': this.userInfoData.boxkey
            }
       };
    }
  },
  methods:{  
    handleCloseNew(){
      localStorage.setItem('readNew2', 1);
      this.modalNew = false
    },
    insideGAM(){
       let flag = false
       if(this.userInfoData.role != 'Administrator'){
            if( this.userInfoData.customer.GAM == 1 && this.pack.delivery.code == 1 ) {
                flag = true
            } 
       } else {
           flag = true
       }
       return flag;
    },
    successUploaded (file, response) {
        console.log('File', file);
        if(response.url !== ''){
            this.resources.push(response.obj)
            this.pack.resource = response.url+"?v="+this.getRandomNumber();
            this.popupActivo4 = false
        }
    },
    sendingBeforeDropzone (file, xhr, formData) {
        console.log('DEBUG: formData BEFORE ' + formData)
        formData.append('fileName', this.pack.tracking);
        formData.append('type', 'Invoice');
        formData.append('customer', this.assignTo == true ? this.customer.id : null);
    },
    getTotalPayment(){
        let total = 0;
        if(this.costs.length > 0){
            total = parseFloat(this.costs[0].amount) + parseFloat(this.costs[1].amount) + parseFloat(this.costs[2].amount)
        }
        return this.formatNumber(total)
    },
    retrieveResources() {
        ResourceDataService.getFiles('Invoice')
        .then(response => {
            console.log('RE',response.data)
            this.resources = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los archivos!',color:'danger',icon:'error_outline'})
        });
    },    
    retrieveLocationsDelivery() {
        ClientDataService.getLocationsDelivery()
        .then(response => {
            this.deliveries = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los lugares de entrega!',color:'danger',icon:'error_outline'})
        });
    },
    retrieveCustomers() {
        ClientDataService.getAll()
        .then(response => {
            response.data.forEach(element => {
                this.customers.push({
                    id: element.id, 
                    name: element.fullName,
                    email: element.email,
                    customerType: element.typecode
                })
            });
            this.customer = this.customers[0]
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los clientes!',color:'danger',icon:'error_outline'})
        });
    },
    calculator(){
        console.log('CALCULADORA')
        const that = this
        
        that.pack.user         = that.assignTo == true ? that.customer.email : that.userInfoData.email
        that.pack.customer     = that.assignTo == true ? that.customer.id : that.userInfoData.customer.id
        that.pack.customerType = that.assignTo == true ? that.customer.customerType : that.userInfoData.customer.typecode

        PackageDataService.calculatorRate(this.pack)
        .then(response => {
            console.log('EEE')
          this.costs = response.data.result
          this.totalTax = parseFloat(this.costs[1].amount) + parseFloat(this.costs[2].amount)
          if(this.pack.tax.permission){
              this.totalTax = this.totalTax - parseFloat(this.pack.tax.permissionCost)
          }
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error generando los costos!',color:'danger',icon:'error_outline'})                
        });
    },
    // creditInfoChanged(values) {
    //     for (const key in values) {
    //         console.log(key)
    //         switch (key) {
    //             case 'name':
    //                 console.log("====CARD NAME====")
    //                 this.pack.cardName = values[key];
    //                 this.$v.pack.cardName.$model =  values[key];
    //                 break;
    //             case 'cardNumber':
    //                 this.pack.cardNumber = values[key];
    //                 this.$v.pack.cardNumber.$model =  values[key];
    //                 break;
    //             case 'expiration':
    //                 this.pack.cardExp = values[key];
    //                 this.$v.pack.cardExp.$model =  values[key];
    //                 break;
    //             case 'security':
    //                 console.log("====CARD CVC====",values[key])
    //                 this.pack.cardCVC = values[key];
    //                 this.$v.pack.cardCVC.$model =  values[key];
    //                 break;
    //         }
    //         // this[key] = values[key];
    //     }
    // },    
    retrieveTaxes() {
        TaxDataService.getAll()
        .then(response => {
            this.products = response.data;
            this.$Progress.finish()
        })
        .catch(e => {
            console.log(e);
            this.$Progress.finish()
            this.$vs.notify({title:'Error!',text:'Error obteniendo los productos',color:'danger',icon:'error_outline'})
        });
    },
    validStepOneForm(){
        return new Promise((resolve, reject) => {
            console.log(resolve, reject);
            this.$v.pack.tracking.$touch(); this.$v.pack.guide.$touch();
            this.$v.pack.tax.$touch();      this.$v.pack.unit.$touch();
            this.$v.pack.weight.$touch();   this.$v.pack.price.$touch();   
                            
            if (!this.$v.pack.tracking.$invalid && !this.$v.pack.guide.$invalid &&
                !this.$v.pack.tax.$invalid && !this.$v.pack.unit.$invalid &&
                !this.$v.pack.weight.$invalid && !this.$v.pack.price.$invalid) {
                this.calculator();
                resolve(true);
            }else{
                console.log('NO')
                resolve(false);
            }
            // this.calculator();
            // resolve(true);
        })
    },
    validStepTwoForm(){
        return new Promise((resolve, reject) => {
            console.log(resolve, reject);
            this.$v.pack.resource.$touch();
            this.$v.pack.delivery.$touch();   
                            
            if (!this.$v.pack.resource.$invalid && !this.$v.pack.delivery.$invalid) {
                this.calculator();
                resolve(true);
            }else{
                console.log('NO')
                resolve(false);
            }            
            // this.calculator();
            // resolve(true);
        })        
    },
    validTracking(){
        this.$v.pack.tracking.$touch()
        console.log('EMAIL ', this.$v.pack.tracking.$invalid)
        if(!this.$v.pack.tracking.$invalid){
            PackageDataService.validTracking({tracking: this.pack.tracking})
            .then( response => {
                // console.log(response)
                if(response.data.existe == 1){
                    this.errorTracking = 'El número de tracking '+ this.pack.tracking+" ya esta registrado."
                    this.pack.tracking   = ""
                    setTimeout( ()=> {
                        this.errorTracking = ""
                    }, 9400);
                }
            })
            .catch( () => {

                // if(e.response.status == 404){
                //     this.checkMail = false
                // }else{
                //     this.$vs.notify({title:'Información!',text:'Error validando el email',color:'danger',icon:'error_outline'})     
                // }     
            });
        }
    },
    handlePreAlert(){
        this.$v.$touch()
        console.log('FORM PRE',this.$v.$invalid)
        if (this.$v.$invalid) return;
        const that = this
        that.loadingProgress ('#btnPaid', '#1a426d')
        that.confirmStatus = true
        PackageDataService.create(that.pack)
        .then(response => {
            that.confirmStatus = false
            console.log(response)
            that.$vs.loading.close('#btnPaid .con-vs-loading')
            that.ModalActive = false
            this.$router.push({ name: "packages"})
            that.$vs.notify({title:'Información!',text:'El paquete fue pre alertado exitosamente!',color:'success',icon:'check'})
            // that.client    = new ClientModel()
            // this.$v.$reset()
            // this.$refs.wizard.reset();
            // this.retrieveUsers()
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error pre alertando el paquete',color:'danger',icon:'error_outline'})                
        });
           
    },
    isLastStep() {
        if (this.$refs.wizard) {

            return this.$refs.wizard.isLastStep
        }
        return false
    },
    closeModalResource () {
       this.pack.resource = this.resourceSelected.url+"?v="+this.getRandomNumber();
        this.popupActivo4 = false
    },
    findResource(_id){
      let found = this.resources.filter((item) => {
        return  _id === item.id
      })
      if( found.length > 0) {
        this.resourceSelected = found[0]
      }
    },
    removeResource(){
       this.pack.resource = ""
    },
    checkExtension(_url){
        if(this.isPdf(_url)){
           return require('@/assets/images/pdf_icon.png')
        }else{
           return _url
        }
    }
  }
}
</script>
